// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import store from '../../redux/store';
import _ from 'lodash';
import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

function withAccountHeader(axios: AxiosInstance): AxiosInstance {
  axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const state = store.getState();
    const activeAccount = _.get(state, 'account.activeAccount');
    if (!activeAccount) return config;
    else {
      config.headers['LifeOmic-Account'] = activeAccount;
      return config;
    }
  });
  return axios;
}

export default withAccountHeader;
